import { Row, ColumnDef } from "@tanstack/react-table";
import { DataTable } from "@/components/DataTable";
import { Trash2 } from "lucide-react";
import React from "react";
import { TableTabs } from "@/components/DataTable/TableTabs";
import { Button } from "@/components/ui";
import { useTranslation } from "react-i18next";

export const TableTabsMockImplementation = () => {
  const { t } = useTranslation();
  const dateUploadedKey = "dateUploaded";
  const fileNameKey = "fileName";
  const data = [
    {
      [dateUploadedKey]: "January 10, 2025",
      fileName: "Touchpoints - March 10.csv",
      onDownload: () => {
        /* download logic */
      },
      onDelete: () => {
        /* delete logic */
      },
    },
    {
      dateUploaded: "January 10, 2025",
      fileName: "Touchpoints - March 10.csv",
      onDownload: () => {
        /* download logic */
      },
      onDelete: () => {
        /* delete logic */
      },
    },
    {
      dateUploaded: "January 10, 2025",
      fileName: "Touchpoints - March 10.csv",
      onDownload: () => {
        /* download logic */
      },
      onDelete: () => {
        /* delete logic */
      },
    },
    {
      dateUploaded: "January 10, 2025",
      fileName: "Touchpoints - March 10.csv",
      onDownload: () => {
        /* download logic */
      },
      onDelete: () => {
        /* delete logic */
      },
    },
  ];
  const columns: ColumnDef<(typeof data)[0]>[] = [
    {
      id: dateUploadedKey,
      accessorKey: dateUploadedKey,
      header: () => (
        <DataTable.THeaderCell>
          {t("components.tableTabs.dateUploaded")}
        </DataTable.THeaderCell>
      ),
      cell: ({ row }: { row: Row<(typeof data)[0]> }) => {
        return (
          <DataTable.TBodyCell>
            {row.getValue(dateUploadedKey)}
          </DataTable.TBodyCell>
        );
      },
    },
    {
      id: fileNameKey,
      accessorKey: fileNameKey,
      header: () => (
        <DataTable.THeaderCell>
          {t("components.tableTabs.fileName")}
        </DataTable.THeaderCell>
      ),
      cell: ({ row }: { row: Row<(typeof data)[0]> }) => {
        return (
          <DataTable.TBodyCell>{row.getValue(fileNameKey)}</DataTable.TBodyCell>
        );
      },
    },
    {
      id: "download",
      header: "",
      cell: ({ row }) => (
        <DataTable.TBodyCell isLastCell={true}>
          <div className="flex justify-end gap-2">
            <Button
              className="btn btn-outline"
              onClick={row.original.onDownload}
              variant="outline"
            >
              {t("components.tableTabs.download")}
            </Button>
            <Button
              className="btn btn-outline text-red-500"
              onClick={row.original.onDelete}
              variant="outline"
            >
              <Trash2 />
            </Button>
          </div>
        </DataTable.TBodyCell>
      ),
      enableSorting: false,
      enableColumnFilter: false,
    },
  ];
  return (
    <TableTabs
      activeTab={0}
      tabs={[
        {
          label: "Touchpoints Reports",
          value: {
            data,
            columns,
            topHeader: (
              <>
                <DataTable.Title
                  title=""
                  description="Automatically generated Touchpoint reports"
                />
              </>
            ),
            tableHeader: <DataTable.THeader />,
            tableBody: <DataTable.TBody />,
            pagination: (
              <>
                <DataTable.PaginationLabel />
                <DataTable.PaginationControls />
              </>
            ),
          },
        },
        {
          label: "ZeeMee Uploads",
          value: {
            data,
            columns,
            topHeader: (
              <>
                <DataTable.Title title="" description="Your school uploads" />
              </>
            ),
            tableHeader: <DataTable.THeader />,
            tableBody: <DataTable.TBody />,
            pagination: (
              <>
                <DataTable.PaginationLabel />
                <DataTable.PaginationControls />
              </>
            ),
          },
        },
        {
          label: "School uploads",
          value: {
            data,
            columns,
            topHeader: (
              <>
                <DataTable.Title title="" description="Your school uploads" />
              </>
            ),
            tableHeader: <DataTable.THeader />,
            tableBody: <DataTable.TBody />,
            pagination: (
              <>
                <DataTable.PaginationLabel />
                <DataTable.PaginationControls />
              </>
            ),
          },
        },
      ]}
    />
  );
};
